import { type Db, connectivityFetch } from '@shkola/api';
import type { Database } from '@shkola/db-types';
import { createClient } from '@supabase/supabase-js';
import { assertPublicKey } from '../env';

export function createSupabase(url: string, publicKey: string): Db {
  assertPublicKey(publicKey);
  return createClient<Database>(url, publicKey, {
    // a request that cannot reach the server switches the app to its offline copy
    global: { fetch: connectivityFetch(`${url}/auth/v1/health`, { apikey: publicKey }) },
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  });
}
